import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Fade,
  Alert,
  Paper
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const SubscriptionFailure: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ 
      minHeight: '80vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      p: 3,
      bgcolor: 'background.default'
    }}>
      <Fade in>
        <Card sx={{ maxWidth: 550, width: '100%', borderRadius: 4 }}>
          {/* Header */}
          <Box sx={{ 
            bgcolor: 'error.main',
            color: 'primary.contrastText',
            p: 4,
            textAlign: 'center',
            borderRadius: '16px 16px 0 0'
          }}>
            <ErrorOutlineIcon sx={{ fontSize: 64, mb: 2 }} />
            <Typography variant="h4" fontWeight="bold">
              Payment Cancelled
            </Typography>
          </Box>

          <CardContent sx={{ p: 4 }}>
            <Alert severity="info" sx={{ mb: 3 }}>
              No charges were made to your account.
            </Alert>

            <Typography variant="body1" color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
              Your payment was not completed. This could be because:
            </Typography>

            <Paper variant="outlined" sx={{ p: 3, mb: 3, borderRadius: 2 }}>
              <Box component="ul" sx={{ m: 0, pl: 2 }}>
                <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                  You cancelled the payment process
                </Typography>
                <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                  The payment method was declined
                </Typography>
                <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                  The session timed out
                </Typography>
                <Typography component="li" variant="body2">
                  There was a technical issue
                </Typography>
              </Box>
            </Paper>

            <Typography variant="body1" sx={{ mb: 3, textAlign: 'center' }}>
              You can try again whenever you're ready. Your account remains active with free features.
            </Typography>

            <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
              <Button
                fullWidth
                variant="contained"
                size="large"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate('/subscription')}
                sx={{ borderRadius: 2 }}
              >
                Try Again
              </Button>
              <Button
                fullWidth
                variant="outlined"
                size="large"
                startIcon={<HelpOutlineIcon />}
                onClick={() => navigate('/dashboard')}
                sx={{ borderRadius: 2 }}
              >
                Go to Dashboard
              </Button>
            </Box>

            <Typography variant="caption" color="text.secondary" sx={{ mt: 3, textAlign: 'center', display: 'block' }}>
              Need help? Contact support at support@levelupteaching.ai
            </Typography>
          </CardContent>
        </Card>
      </Fade>
    </Box>
  );
};

export default SubscriptionFailure;
